<script>
import {
  computed, inject, watch, ref, onMounted,
} from '@vue/composition-api'
import { useRouter } from '@core/utils'
import store from '@/store'

export default {
  name: 'AppTitle',
  setup() {
    const { route, router } = useRouter()
    const menusList = inject('menus')
    const flatMenusList = ref([])
    const title = computed(() => router.currentRoute.meta?.pageTitle || '')
    const titleObj = computed(() => store.state?.app?.titleObj || {})
    const appTitles = ref([])

    const flatMenus = arr => {
      const res = []
      arr.forEach(item => {
        if (item.children) {
          res.push(...flatMenus(item.children.map(child => ({
            ...child,
          }))))
        } else {
          res.push({
            route: item.route,
            pageTitle: item.name || '',
          })
        }
      })

      return res
    }
    const checkRouteInMenus = () => flatMenusList.value.some(item => item.route === router.currentRoute.name)

    const setAppTitles = () => {
      if (!checkRouteInMenus()) {
        appTitles.value = JSON.parse(sessionStorage.getItem('appTitles')) || []

        // 判断route是否在缓存栈中，存在则出去栈以后的数据
        if (appTitles.value.some(item => item.route === router.currentRoute.name)) {
          appTitles.value.splice(appTitles.value.findIndex(item => item.route === router.currentRoute.name) + 1, appTitles.value.length - 1)
        } else {
          const newMeta = {
            route: router.currentRoute.name,
            pageTitle: titleObj.value.pageTitle || router.currentRoute?.meta?.pageTitle || '',
            query: router.currentRoute.query,
          }
          appTitles.value.push({
            ...newMeta,
          })
        }
      } else {
        appTitles.value = [{
          route: router.currentRoute.name,
          pageTitle: titleObj.value.pageTitle || router.currentRoute?.meta?.pageTitle || '工作台',
          query: router.currentRoute.query,
        }]
      }
      if (appTitles.value.length) {
        sessionStorage.setItem('appTitles', JSON.stringify(appTitles.value || []))
      }
    }

    watch(() => menusList, () => {
      flatMenusList.value = flatMenus(menusList.value)
      setAppTitles()
    }, { deep: true })

    watch(() => route.value.name, () => {
      setAppTitles()
    })

    onMounted(() => {
      flatMenusList.value = flatMenus(menusList.value)
      setAppTitles()
    })

    const goBack = () => {
      router.push({ name: appTitles.value[appTitles.value.length - 2].route, query: appTitles.value[appTitles.value.length - 2].query })
    }

    const goRoute = item => {
      router.push({ name: item.route, query: item.query })
    }

    return {
      menusList,
      title,
      titleObj,
      appTitles,
      goBack,
      goRoute,
    }
  },
}
</script>

<template>
  <div
    class="text-h7 font-weight-black title-line"
  >
    <span v-if="appTitles.length > 1" class="iconfont icon-a-xialakuang2x" @click="goBack"></span>
    <div class="app-titles">
      <div v-for="item in appTitles" :key="item.name" class="app-item" @click="goRoute(item)">
        {{ item.pageTitle }}
      </div>
    </div>
  </div>
</template>

<style scoped lang='scss'>
.title-line {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: -20px;
}
.iconfont{
    transform: rotate(90deg);
    display: block;
    margin-right: 4px;
    cursor: pointer;
  }
  .app-titles{
    display: flex;
  }
  .app-item{
    cursor: pointer;
    margin: 0 5px;
    display: flex;
    font-size: 18px;
    font-weight: bold;
  }
  .app-item::after{
    content: '/';
    margin-left: 10px;
    display: block;
    color: rgba(0,0,0,0.6);
  }
  .app-item:hover,.iconfont:hover{
    color: rgba(0,0,0,0.8);
  }
  .app-item:last-child::after{
    display: none;
  }
  .app-item:last-child{
    color: rgba(0,0,0,0.8);
    cursor: default;
  }
</style>
